export function formatDate(dateString: string): string {
  const date = new Date(dateString);
  return date.toLocaleDateString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

/**
 * Converts a YYYY-MM-DD backend date string to DD/MM/YYYY without any Date
 * object conversion, avoiding the GMT-3 D-1 shift entirely.
 * Also handles ISO datetime strings (slices to the date part before formatting).
 */
export function formatDateBR(dateStr: string): string {
  if (!dateStr) return '—';
  const [y, m, d] = dateStr.slice(0, 10).split('-');
  if (!d) return dateStr;
  return `${d}/${m}/${y}`;
}
